var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Welcome to LiveCad 3.0!")]),_c('HomeUnauthenticated')],1)}
var staticRenderFns = []

export { render, staticRenderFns }